import { AxiosBookings, AxiosMULEEX, orgId } from "../apiConfig";
import { appendQueryParams } from "../../utilities/urlUtils";


export const pricingAndCollectionsApiFactory = {
  $_getBillingSettings(orgId, packageType, transType) {
    const url = `billing-setting/org/${orgId}?package_type=${packageType}&tran_type=${transType}`;
    return AxiosBookings.get(url);
  },
  $_getBillingRate() {
    const url = 'billing-setting/mulex';
    return AxiosBookings.get(url);
  },
  $_createBillingSetting(payload) {
    const url = 'billing-setting/';
    return AxiosBookings.post(url, payload);
  },
  $_simulateCost(payload) {
    const url = '/cost-engine/stimulate-cost/';
    return AxiosBookings.post(url, payload);
  },
  $_priceIndicator(payload) {
    const url = '/billing-setting/price-indecator';
    return AxiosBookings.post(url, payload);
  },
  $_editBillingSetting(payload, billingSettingId) {
    const url = `billing-setting/${billingSettingId}`;
    return AxiosBookings.patch(url, payload);
  },
  $_editAccount(payload, id) {
    const url = `collection/account/${id}`;
    return AxiosBookings.patch(url, payload);
  },
  $_createAccount(payload) {
    const url = `collection/account`;
    return AxiosBookings.post(url, payload);
  },
  $_getAccounts(params) {
    const url = `collection/account/org/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_createAssociate(payload) {
    const url = `collection/associate`;
    return AxiosBookings.post(url, payload);
  },
  $_editAssociate(payload, id) {
    const url = `collection/associate/${id}`;
    return AxiosBookings.patch(url, payload);
  },
  $_deleteAssociate(id) {
    const url = `collection/associate/${id}`;
    return AxiosBookings.delete(url);
  },
  $_defaultAssociate(payload) {
    const url = `collection/associate/default`;
    return AxiosBookings.patch(url, payload);
  },
  $_getAssociates(params) {
    const url = `collection/associate/org/${orgId()}${appendQueryParams(params)}`;
    return AxiosBookings.get(url);
  },
  $_getLocation(orgId) {
    const url = `location/get-all-location/${orgId}`;
    return AxiosMULEEX.get(url);
  },
  $_getAllBanks() {
    const url = `creditcard/banklist`;
    return AxiosBookings.get(url);
  },
  $_getAccountInfo(payload) {
    const url = `creditcard/accname`;
    return AxiosBookings.post(url, payload);
  },
  $_deletePricing(id) {
    const url = `billing-setting/${id}`;
    return AxiosBookings.delete(url);
  },
  $_deleteAccount(id) {
    const url = `collection/associate/${id}`;
    return AxiosBookings.delete(url);
  },
};  
